/* src/app/webhook-creator/webhook-creator/view/marketplace-viewer.component.scss */
:root {
  --divider-color: var(--tem-accent);
}
nz-icon {
  margin-right: 6px;
  font-size: 24px;
}
.drawer-content {
  height: 100%;
  position: relative;
  overflow: auto;
}
.resizer-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
  height: 100%;
  cursor: ew-resize;
  z-index: 10;
}
nz-divider::after,
nz-divider::before {
  border-color: var(--tem-accent) !important;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.button {
  float: right;
  display: flex;
  flex-direction: row;
  bottom: 0;
  right: 10px;
  margin-bottom: 10px;
  margin-right: 40px;
  align-self: flex-end;
}
/*# sourceMappingURL=marketplace-viewer.component.css.map */
